import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { PoModule } from '@po-ui/ng-components';
import { PoTemplatesModule } from '@po-ui/ng-templates';
import { PoCodeEditorModule } from '@po-ui/ng-code-editor';

import { MainService } from 'src/app/app.service';
import { ReviewService } from './review/review.service';
import { ReviewComponent } from './review/review.component';
import { ReviewDetailComponent } from './review/components/review-detail/review-detail.component';
import { SendReviewModalComponent } from './review/components/send-review-modal/send-review-modal.component';
import { ChangesetTableComponent } from './review/components/send-review-modal/changeset-table/changeset-table.component';
import { RetryJobModalComponent } from './review/components/retry-job-modal/retry-job-modal.component';
import { AnnotationsPanelComponent } from './review/components/annotations-panel/annotations-panel.component';
import { ReviewFeedbackComponent } from './review/components/review-feedback/review-feedback.component';
import { ReviewOtherFeedbackComponent } from './review/components/review-other-feedback/review-other-feedback.component';
import { ReviewMonacoViewerComponent } from './review/components/review-monaco-viewer/review-monaco-viewer.component';
import { AdminShellComponent } from './admin/admin-shell/admin-shell.component';
import { AdminGatesComponent } from './admin/gates/admin-gates.component';
import { GatesService } from './admin/gates/gates.service';
import { JobsService } from './core/api/jobs.service';
import { TfvcService } from './core/api/tfvc.service';
import { GitService } from './core/api/git.service';
import { SmartReviewAccessService } from './core/api/smart-review-access.service';
import { MarkdownPipe } from './review/pipes/markdown.pipe';
import { NotificationItemComponent } from '../notification-item/notification-item.component';
import { CurationService } from './admin/curation/curation.service';
import { CurationQueueComponent } from './admin/curation/components/curation-queue/curation-queue.component';
import { CurationModalComponent } from './admin/curation/components/curation-modal/curation-modal.component';
import { CurationStatsComponent } from './admin/curation/components/curation-stats/curation-stats.component';
import { PeriodFilterModule } from 'src/app/shared/period/period-filter.module';
import { CostsService } from './admin/costs/costs.service';
import { CostsPanelComponent } from './admin/costs/components/costs-panel/costs-panel.component';
import { CostsKpisComponent } from './admin/costs/components/costs-kpis/costs-kpis.component';
import { CostsTimeseriesChartComponent } from './admin/costs/components/costs-timeseries-chart/costs-timeseries-chart.component';
import { CostsBreakdownTableComponent } from './admin/costs/components/costs-breakdown-table/costs-breakdown-table.component';
import { CostsBreakdownSectionComponent } from './admin/costs/components/costs-breakdown-section/costs-breakdown-section.component';
import { CostsAreasService } from './admin/costs/costs-areas.service';
import { CostsExportService } from './admin/costs/costs-export.service';
import { AdminRepositoriesComponent } from './admin/repositories/admin-repositories.component';
import { RepositoriesService } from './admin/repositories/repositories.service';
import { ReviewStatsService } from './dashboard/review-stats.service';
import { ReviewDashboardComponent } from './dashboard/review-dashboard.component';
import { ReviewStatsKpisComponent } from './dashboard/components/review-stats-kpis/review-stats-kpis.component';
import { ReviewStatsFeedbackComponent } from './dashboard/components/review-stats-feedback/review-stats-feedback.component';
import { ReviewStatsSeverityComponent } from './dashboard/components/review-stats-severity/review-stats-severity.component';
import { ReviewStatsTimeseriesChartComponent } from './dashboard/components/review-stats-timeseries-chart/review-stats-timeseries-chart.component';
import { ReviewStatsBreakdownComponent } from './dashboard/components/review-stats-breakdown/review-stats-breakdown.component';
import { ReviewStatsHotspotsComponent } from './dashboard/components/review-stats-hotspots/review-stats-hotspots.component';
import { ReviewStatsAttentionComponent } from './dashboard/components/review-stats-attention/review-stats-attention.component';
import { ReviewStatsFileFindingsComponent } from './dashboard/components/review-stats-file-findings/review-stats-file-findings.component';
import { ReviewStatsAttentionSummaryComponent } from './dashboard/components/review-stats-attention-summary/review-stats-attention-summary.component';
import { ReviewStatsHotspotsSummaryComponent } from './dashboard/components/review-stats-hotspots-summary/review-stats-hotspots-summary.component';
import { ReviewStatsHealthErrorsComponent } from './dashboard/components/review-stats-health-errors/review-stats-health-errors.component';
import { ReviewStatsCalibrationComponent } from './dashboard/components/review-stats-calibration/review-stats-calibration.component';

@NgModule({
  declarations: [
    ReviewComponent,
    ReviewDetailComponent,
    ReviewMonacoViewerComponent,
    SendReviewModalComponent,
    ChangesetTableComponent,
    RetryJobModalComponent,
    AdminShellComponent,
    AdminGatesComponent,
    AnnotationsPanelComponent,
    ReviewFeedbackComponent,
    ReviewOtherFeedbackComponent,
    CurationQueueComponent,
    CurationModalComponent,
    CurationStatsComponent,
    CostsPanelComponent,
    CostsKpisComponent,
    CostsTimeseriesChartComponent,
    CostsBreakdownTableComponent,
    CostsBreakdownSectionComponent,
    AdminRepositoriesComponent,
    ReviewDashboardComponent,
    ReviewStatsKpisComponent,
    ReviewStatsFeedbackComponent,
    ReviewStatsSeverityComponent,
    ReviewStatsTimeseriesChartComponent,
    ReviewStatsBreakdownComponent,
    ReviewStatsHotspotsComponent,
    ReviewStatsAttentionComponent,
    ReviewStatsCalibrationComponent,
    ReviewStatsHealthErrorsComponent,
    ReviewStatsAttentionSummaryComponent,
    ReviewStatsHotspotsSummaryComponent,
    ReviewStatsFileFindingsComponent,
    MarkdownPipe
  ],
  imports: [
    PeriodFilterModule,
    CommonModule,
    FormsModule,
    RouterModule,
    PoModule,
    PoTemplatesModule,
    PoCodeEditorModule,
    NotificationItemComponent
  ],
  providers: [
    MainService,
    ReviewService,
    GatesService,
    JobsService,
    TfvcService,
    GitService,
    SmartReviewAccessService,
    CurationService,
    CostsService,
    CostsAreasService,
    CostsExportService,
    RepositoriesService,
    ReviewStatsService
  ]
})
export class SmartReviewModule {}
